import cdnConfig from './config';
export { assetTypes } from './config';
export function getCDNPath(assetType) {
  var customCDN = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (customCDN && customCDN.cdnUrl && customCDN.assetsPath && customCDN.assetsPath[assetType]) {
    return "".concat(customCDN.cdnUrl).concat(customCDN.assetsPath[assetType]);
  }

  if (cdnConfig.assetsPath[assetType] && cdnConfig.cdnUrl) {
    return "".concat(cdnConfig.cdnUrl).concat(cdnConfig.assetsPath[assetType]);
  }

  throw new Error("Paths for asset type ".concat(assetType, " is not defined in CDN configuration.\n        If you have provided a custom CDN configuration make sure it follows the Prop Types defined"));
}